import axios from 'axios';

// Base API Instance
// Assuming the .NET 9 API runs on localhost:5048 and the React frontend on localhost:5173
const apiClient = axios.create({
    baseURL: import.meta.env.VITE_API_URL || 'http://localhost:5048/api',
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request Interceptor: Attach JWT Token and Language defaults
apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('mosaik_admin_token');
        if (token) {
            config.headers.set('Authorization', `Bearer ${token}`);
        }

        // Optional: Attach selected language logic from settings/context
        const lang = localStorage.getItem('mosaik_language') || 'de';
        config.headers['Accept-Language'] = lang;

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response Interceptor: Handle 401 Unauthorized globally
apiClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // If we receive a 401 Unauthorized, the token has expired or is invalid.
        if (error.response && error.response.status === 401) {
            // Avoid infinite login loops by safely checking current pathname
            if (window.location.pathname !== '/admin/login') {
                localStorage.removeItem('mosaik_admin_token');
                window.location.href = '/admin/login';
            }
        }
        return Promise.reject(error);
    }
);

export default apiClient;
